
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.541 3.55a.623.623 0 00-.416.16l-1.75 1.565-1.75-1.564a.626.626 0 00-.834 0L9.039 5.277 7.29 3.73a.625.625 0 00-1.039.467v11.125H4.125a.625.625 0 00-.625.625v1.522a2.982 2.982 0 002.875 2.976v.002h4.547a.626.626 0 000-1.252h-.947c-.02 0-.038 0-.057.002H6.473A1.73 1.73 0 014.75 17.47v-.897h4.63l.04.002h.947a.626.626 0 100-1.252H7.5V5.586l1.127.996c.237.21.596.21.832-.002l1.75-1.564 1.75 1.564a.623.623 0 00.832 0l1.75-1.564 1.75 1.564a.627.627 0 00.832.002l1.127-.996v5.508a.626.626 0 001.252 0v-.95c0-.019 0-.037-.002-.056v-5.89a.624.624 0 00-1.04-.468l-1.75 1.547-1.751-1.566a.627.627 0 00-.418-.16zM10 9.136a.625.625 0 100 1.25h3.854a.625.625 0 100-1.25H10zM17 12a5 5 0 100 10 5 5 0 000-10zm-7 .053a.625.625 0 100 1.25h2.07a.625.625 0 100-1.25H10zm7 1.447a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1.25a.751.751 0 00-.75.75v.75h-.75a.751.751 0 000 1.5h.75v.75a.751.751 0 001.5 0v-.75h.75a.751.751 0 000-1.5h-.75v-.75a.751.751 0 00-.75-.75z"}})])
          )
        }
      }
    